<template>
    <PageLoading v-if="isLoading" />

    <div v-else class="main-wrap course-single-page">
        <div v-if="!courseIsEmpty" class="row">
            <div class="col-12 col-lg-6 row column">
                <div
                    class="course-header"
                    :style="{ 'background-image': 'url(' + courseImage + ')' }"
                >
                    <div class="overlay">
                        <!-- course type title display -->
                        <div
                            v-if="course.courses_coursetype"
                            class="course-type row items-center"
                        >
                            <template
                                v-if="
                                    course.courses_coursetype.slug === 'online'
                                "
                            >
                                <q-icon name="language" class="q-mr-sm">
                                </q-icon>

                                {{ $t('general.online') }}
                            </template>

                            <template
                                v-if="
                                    course.courses_coursetype.slug ===
                                    'presencial'
                                "
                            >
                                <q-icon name="business" class="q-mr-sm">
                                </q-icon>

                                {{ $t('general.presential') }}
                            </template>

                            <div v-if="course.on_promotion" class="promotion">
                                <q-icon name="sell" class="q-mr-sm"> </q-icon>

                                {{
                                    course.promotion_discount +
                                    '% ' +
                                    $t('general.discount')
                                }}
                            </div>
                        </div>
                        <!-- course title -->
                        <h1>
                            {{
                                JSONParseTranslations(course.title, locale.key)
                            }}
                        </h1>
                        <!-- if student has this course and it's an online course -->
                        <template
                            v-if="
                                hasCourse &&
                                course.courses_coursetype &&
                                course.courses_coursetype.slug === 'online'
                            "
                        >
                            <q-btn
                                class="title-btn q-mr-md"
                                color="primary"
                                :to="{
                                    name: 'CourseLearn',
                                    params: {
                                        id: course.id,
                                        lessonId: 1,
                                    },
                                }"
                            >
                                <q-icon name="school" class="q-mr-lg"> </q-icon>

                                <span>
                                    {{ $t('courses.start_lessons') }}
                                </span>
                            </q-btn>
                        </template>
                        <!-- if course can be boughted -->
                        <template v-if="course.can_buy">
                            <q-btn
                                class="title-btn"
                                color="primary"
                                @click="addToCart(course)"
                            >
                                <q-icon
                                    name="eva-shopping-cart-outline"
                                    class="q-mr-lg"
                                >
                                </q-icon>

                                <div class="col text-right">
                                    <span
                                        v-if="course.on_promotion"
                                        class="small-text"
                                    >
                                        <em>({{ $t('general.with_vat') }})</em>

                                        <span class="small-text text-strike">
                                            {{
                                                new Intl.NumberFormat(
                                                    currency.definition[
                                                        'locale'
                                                    ],
                                                    {
                                                        style: 'currency',
                                                        currency: currency.key,
                                                    }
                                                ).format(PriceWithoutVat)
                                            }}
                                        </span>

                                        <br />
                                    </span>

                                    <em v-if="!course.on_promotion">
                                        ({{ $t('general.with_vat') }})
                                    </em>

                                    {{
                                        new Intl.NumberFormat(
                                            currency.definition['locale'],
                                            {
                                                style: 'currency',
                                                currency: currency.key,
                                            }
                                        ).format(PriceWithVat)
                                    }}

                                    <!-- <template v-if="course.on_promotion"><br><em> ({{
                                        course.promotion_discount +
                                        '% ' +
                                        $t('general.discount')
                                    }})</em></template> -->
                                </div>
                            </q-btn>
                        </template>
                        <template v-else>
                            <q-btn
                                class="title-btn"
                                color="primary"
                                @click="showForm"
                            >
                                <q-icon name="mail_outline" class="q-mr-lg">
                                </q-icon>

                                <div>
                                    <span>{{
                                        $t('general.request_more_information')
                                    }}</span>
                                </div>
                            </q-btn>
                        </template>
                    </div>

                    <div class="quick-actions">
                        <q-btn
                            class="q-px-lg"
                            icon="o_favorite"
                            size="16px"
                            :disable="
                                isAddingToWishlist ||
                                isRemovingFromWishlist ||
                                isFetchingWishlist
                            "
                            :class="{ onWishlist: wishlist.length }"
                            @click="manageWishlist"
                        >
                            <q-tooltip>
                                {{
                                    wishlist.length
                                        ? $t('actions.remove_from_wishlist')
                                        : $t('actions.add_to_wishlist')
                                }}
                            </q-tooltip>
                        </q-btn>

                        <!-- TODO: Comment for the lecture -->
                        <!-- TODO: We still need to  fix the button functionality -->
                        <!-- <q-btn class="q-px-lg q-mx-md" icon="share" size="16px">
                            <q-tooltip>
                                {{ $t('actions.share_on_social_networks') }}
                            </q-tooltip>
                        </q-btn> -->
                    </div>
                </div>

                <div class="col course-description">
                    <h2>{{ $t('courses.about_course') }}</h2>

                    <div
                        class="text-wrap"
                        v-html="JSONParseTranslations(course.about, locale.key)"
                    ></div>

                    <q-space class="q-my-xl" />

                    <h2>{{ $t('courses.general-objective') }}</h2>

                    <div
                        class="text-wrap"
                        v-html="
                            JSONParseTranslations(
                                course.main_objectives,
                                locale.key
                            )
                        "
                    ></div>

                    <q-space class="q-my-xl" />

                    <h2>{{ $t('courses.specific-objectives') }}</h2>

                    <div
                        class="text-wrap"
                        v-html="
                            JSONParseTranslations(
                                course.specific_objectives,
                                locale.key
                            )
                        "
                    ></div>

                    <q-space class="q-my-xl" />

                    <!-- Requirements -->
                    <h2>{{ $t('general.requirements') }}</h2>

                    <div
                        class="text-wrap"
                        v-html="
                            JSONParseTranslations(
                                course.requirements,
                                locale.key
                            )
                        "
                    ></div>

                    <q-space class="q-my-xl" />

                    <!-- Target Audience -->
                    <h2>{{ $t('general.target_audience') }}</h2>

                    <div
                        class="text-wrap"
                        v-html="
                            JSONParseTranslations(
                                course.target_audience,
                                locale.key
                            )
                        "
                    ></div>

                    <q-space class="q-my-xl" />

                    <h2>{{ $t('courses.workload') }}</h2>

                    <div class="text-wrap">
                        {{
                            $t('courses.duration') +
                            ': ' +
                            course.duration +
                            ' ' +
                            $tc('general.time', 2)
                        }}
                    </div>

                    <div v-if="course.duration_description" class="text-wrap">
                        {{ $t('courses.distribution') + ': ' }}

                        <span
                            v-html="
                                JSONParseTranslations(
                                    course.duration_description,
                                    locale.key
                                )
                            "
                        ></span>
                    </div>

                    <q-space class="q-my-xl" />

                    <h2>{{ $tc('general.partners', 1) }}</h2>

                    <router-link
                        :to="{
                            name: 'PartnersDetails',
                            params: {
                                partnerId: course.partner_id,
                            },
                        }"
                    >
                        <div
                            class="text-wrap"
                            v-html="
                                JSONParseTranslations(
                                    course.courses_partners.title,
                                    locale.key
                                )
                            "
                        ></div>
                    </router-link>

                    <q-space class="q-my-xl" />

                    <h2>{{ $tc('general.training_areas', 1) }}</h2>

                    <router-link
                        :to="{
                            name: 'Courses',
                            params: { areaId: course.area_id },
                        }"
                    >
                        <div
                            class="text-wrap"
                            v-html="
                                JSONParseTranslations(
                                    course.courses_areas.title,
                                    locale.key
                                )
                            "
                        ></div>
                    </router-link>

                    <q-space class="q-my-xl" />

                    <template v-if="course.locale_id && course.course_locales">
                        <h2>{{ $t('courses.content_language') }}</h2>

                        <div class="text-wrap">
                            <span>{{
                                JSONParseTranslations(
                                    course.course_locales.description,
                                    locale.key
                                )
                            }}</span>
                        </div>
                    </template>

                    <q-space class="q-my-xl" />

                    <!-- Certification -->
                    <h2>{{ $t('certificates.certification') }}</h2>

                    <div
                        class="text-wrap"
                        v-html="
                            JSONParseTranslations(
                                course.certification,
                                locale.key
                            )
                        "
                    ></div>

                    <q-space class="q-my-xl" />

                    <!-- Form button to request more information -->
                    <div class="col-12 col-lg-6 q-mt-xl">
                        <q-btn
                            color="primary"
                            text-color="black"
                            @click="showForm"
                        >
                            <q-icon name="mail_outline" class="q-mr-sm">
                            </q-icon>

                            <span>
                                {{ $t('general.request_more_information') }}
                            </span>
                        </q-btn>

                        <q-dialog v-model="contactForm" @input="toggleDialog">
                            <q-card style="max-width: 900px">
                                <q-card-section>
                                    <h2 class="text-capitalize">
                                        {{ $t('general.contact') }}
                                    </h2>
                                </q-card-section>

                                <q-card-section>
                                    <ContactForm
                                        :user="user"
                                        :subject="form.subject"
                                        :message="form.message"
                                        :cancel="true"
                                        @toggle-dialog="toggleDialog"
                                    />
                                </q-card-section>
                            </q-card>
                        </q-dialog>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-6">
                <div class="pricing">
                    <h2>{{ $t('general.pricing') }}</h2>

                    <div v-if="course.on_promotion" class="row q-mt-lg">
                        <em class="text-body1 text-secondary">
                            ({{
                                course.promotion_discount +
                                '% ' +
                                $t('general.discount')
                            }})
                        </em>
                    </div>

                    <div v-if="course.can_buy">
                        <div class="row items-center">
                            <span class="text-h5">
                                {{
                                    new Intl.NumberFormat(
                                        currency.definition['locale'],
                                        {
                                            style: 'currency',
                                            currency: currency.key,
                                        }
                                    ).format(PriceWithoutVat)
                                }}
                            </span>

                            <em class="text-body1 q-ml-sm">
                                ({{ $t('general.without_vat') }})
                            </em>
                        </div>

                        <div class="row items-center">
                            <span class="text-h5">
                                {{
                                    new Intl.NumberFormat(
                                        currency.definition['locale'],
                                        {
                                            style: 'currency',
                                            currency: currency.key,
                                        }
                                    ).format(PriceWithVat)
                                }}
                            </span>

                            <em class="text-body1 q-ml-sm">
                                ({{ $t('general.with_vat') }})
                            </em>
                        </div>
                    </div>

                    <div v-else>
                        {{
                            $t(
                                'general.request_more_information_about_this_course'
                            )
                        }}
                    </div>
                </div>

                <div v-if="course.courses_packagetypes" class="course-features">
                    <template
                        v-if="
                            course.courses_packagetypes.system_slug === 'pacote'
                        "
                    >
                        <h2>{{ $t('courses.packaged_courses') }}</h2>

                        <q-list>
                            <template
                                v-for="(
                                    packagedCourse, index
                                ) in course.coursesInPackages"
                            >
                                <q-expansion-item
                                    v-if="packagedCourse.summary"
                                    :key="index"
                                    expand-icon-class="feature-expand-icon"
                                    class="feature-title"
                                    icon="done"
                                    :label="
                                        JSONParseTranslations(
                                            packagedCourse.title,
                                            locale.key
                                        )
                                    "
                                >
                                    <q-card>
                                        <q-card-section class="feature-section">
                                            <ul>
                                                <li
                                                    v-html="
                                                        JSONParseTranslations(
                                                            packagedCourse.about,
                                                            locale.key
                                                        )
                                                    "
                                                ></li>

                                                <li>
                                                    <router-link
                                                        flat
                                                        class="text-secondary text-h6 text-capitalize"
                                                        :to="{
                                                            name:
                                                                'CourseDetails',
                                                            params: {
                                                                id:
                                                                    packagedCourse.id,
                                                            },
                                                        }"
                                                        target="_blank"
                                                    >
                                                        <span>{{
                                                            $t(
                                                                'general.see_course'
                                                            )
                                                        }}</span>

                                                        <q-icon
                                                            name="school"
                                                            size="20px"
                                                            class="q-ml-sm"
                                                        />
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </q-card-section>
                                    </q-card>
                                </q-expansion-item>

                                <div v-else :key="index" class="feature-title">
                                    <q-item>
                                        <q-item-section avatar>
                                            <q-icon name="done" />
                                        </q-item-section>

                                        <q-item-section>
                                            <q-item-label>
                                                {{
                                                    JSONParseTranslations(
                                                        packgedCourse.title,
                                                        locale.key
                                                    )
                                                }}
                                            </q-item-label>
                                        </q-item-section>
                                    </q-item>
                                </div>
                            </template>
                        </q-list>
                    </template>

                    <template v-else>
                        <h2>{{ $t('courses.lessons_title') }}</h2>

                        <q-list v-if="course.chapters_list">
                            <template
                                v-for="(chapter, index) in course.chapters_list[
                                    locale.key
                                ]"
                            >
                                <q-expansion-item
                                    v-if="chapter.children.length > 0"
                                    :key="index"
                                    expand-icon-class="feature-expand-icon"
                                    class="feature-title"
                                    icon="done"
                                    :label="chapter.title"
                                >
                                    <q-card>
                                        <q-card-section class="feature-section">
                                            <ul>
                                                <li
                                                    v-for="(
                                                        chapterItem, lessonIndex
                                                    ) in chapter.children"
                                                    :key="lessonIndex"
                                                >
                                                    {{ chapterItem.title }}
                                                </li>
                                            </ul>
                                        </q-card-section>
                                    </q-card>
                                </q-expansion-item>

                                <div v-else :key="index" class="feature-title">
                                    <q-item>
                                        <q-item-section avatar>
                                            <q-icon name="done" />
                                        </q-item-section>

                                        <q-item-section>
                                            <q-item-label>{{
                                                chapter.title
                                            }}</q-item-label>
                                        </q-item-section>
                                    </q-item>
                                </div>
                            </template>
                        </q-list>
                    </template>
                </div>
            </div>
        </div>

        <div v-else class="no-data">
            <h4>{{ $t('notify.no_course_details_to_show') }}</h4>
        </div>

        <CourseClasses
            :show="classesShow"
            :course="course"
            @hide-classes="hideClasses"
        />
    </div>
</template>

<script>
import translate from '@/local-shared/mixins/translate'
import PageLoading from '@/components/PageLoading'
import ContactForm from '@/components/ContactForm'
import CourseClasses from '@/components/CourseClasses'
// import lessonsService from '@/services/modules/lessons'
import coursesService from '@/services/modules/courses'
import libraryService from '@/services/modules/libraries'
import picturesService from '@/services/pictures'
import wishlistService from '@/services/modules/wishlist'
import encoders from '@/helpers/encoders'
import store from '@/store'
import _ from 'lodash'

const loadingKeys = {
    fetchingCourse: 'fetching-course',
    fetchingLessons: 'fetching-lessons',
    addingToWishlist: 'adding-to-wishlist',
    removingFromWishlist: 'removing-from-wishlist',
    fetchingWishlist: 'fetching-wishlist',
    fetchingCurrencies: 'fetching-currencies',
}

export default {
    name: 'CourseDetails',

    components: {
        PageLoading,
        ContactForm,
        CourseClasses,
    },

    mixins: [translate],

    data() {
        return {
            course: {},
            courseImage: '',

            units: [],

            classesShow: false,

            wishlist: [],

            contactForm: false,
            form: {
                subject: '',
                message: '',
            },

            library: [],
            hasCourse: false,

            currencies: [],
        }
    },

    computed: {
        isLoading() {
            return this.isFetchingCourse || this.isFetchingLessons
        },

        isFetchingCourse() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingCourse
            ).length
        },

        isFetchingLessons() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingLessons
            ).length
        },

        isAddingToWishlist() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.addingToWishlist
            ).length
        },

        isRemovingFromWishlist() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.removingFromWishlist
            ).length
        },

        isFetchingWishlist() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingWishlist
            ).length
        },

        user() {
            return store.getters['session/user']
        },

        locale() {
            return store.getters['locale/currentLocale']
        },

        currency() {
            return store.getters['currency/currentCurrency']
        },

        PriceWithoutVat() {
            let discount = this.course.on_promotion
                ? 1 - this.course.promotion_discount / 100
                : 1

            return this.course.price[this.currency.key]
                ? (this.course.price[this.currency.key] * discount).toFixed(2)
                : 0
        },

        PriceWithVat() {
            let vat = this.course.vat
                ? parseInt(this.course.vat.value) / 100
                : 0
            let discount = this.course.on_promotion
                ? 1 - this.course.promotion_discount / 100
                : 1

            return this.course.price[this.currency.key]
                ? (
                      this.course.price[this.currency.key] *
                      (1 + vat) *
                      discount
                  ).toFixed(2)
                : 0
        },

        courseIsEmpty() {
            return _.isEmpty(this.course)
        },
    },

    async created() {
        if (this.user) {
            // if user is logged in
            await this.fetchWishlist()
            await this.fetchLibrary()
        }
        await this.fetchCourse()
        this.ifOwnsCourse()
    },

    methods: {
        addToCart(course) {
            if (course.courses_coursetype.slug === 'presencial') {
                this.showClasses()
            } else {
                this.$store.commit('cart/addItemToCart', course)
            }
        },

        showClasses() {
            this.classesShow = true
        },

        hideClasses() {
            this.classesShow = false
        },

        async fetchImage(pictureId) {
            let imageResponse = await picturesService.retrieveById(pictureId)

            if (imageResponse.status === 200) {
                return encoders.arrayBufferToBase64(imageResponse)
            } else {
                return '' //TODO: add a default image
            }
        },

        async fetchCourse() {
            this.loadingAdd(loadingKeys.fetchingCourse)

            let parameters = {
                filter: {
                    id: this.$route.params.id,
                },
                relations: {
                    coursesInPackages: true,
                    courses_areas: true,
                    courses_partners: true,
                    vat: true,
                    course_locales: true,
                    courses_coursetype: true,
                    courses_packagetypes: true,
                },
            }

            let response = await coursesService.retrieve(parameters)

            if (response.status === 200) {
                this.course = response.data.results[0]

                if (
                    !this.course ||
                    !this.course.published ||
                    !this.course.active
                ) {
                    this.$router.push({ name: '404' })
                }

                this.course.chapters_list = JSON.parse(
                    this.course.chapters_list
                )
                if (this.course.coursepicture_id) {
                    this.courseImage = await this.fetchImage(
                        this.course.coursepicture_id
                    )
                } else {
                    this.courseImage = require('@/assets/logo.svg')
                }
                this.course.price = JSON.parse(this.course.price)
            } else {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('notify.error_occurred', {
                        message: response.data.message,
                    }),
                })
            }

            this.loadingRemove(loadingKeys.fetchingCourse)
        },

        async fetchLibrary() {
            let parameters = {
                filter: {
                    user: this.user.id,
                },
            }

            let response = await libraryService.retrieve(parameters)

            if (response.data.status === 'success') {
                this.library = response.data.results
            } else {
                store.commit(
                    'dialog/showDialog',
                    this.$t('errors.authentication_error')
                )
            }
        },

        ifOwnsCourse() {
            if (
                this.library &&
                this.course &&
                this.user.userRoles.name == 'student'
            ) {
                let hasCourse = this.library.find(
                    (item) => item.course_id === this.course.id
                )
                this.hasCourse = hasCourse ? true : false
            } else {
                this.hasCourse = false
            }
        },

        async addToWishlist() {
            this.loadingAdd(loadingKeys.addingToWishlist)

            let parameters = {
                data: [
                    {
                        course_id: this.course.id,
                        user_id: this.user.id,
                    },
                ],
            }

            let response = await wishlistService.create(parameters)

            if (response.status !== 200) {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('notify.error_occurred', {
                        message: response.data.message,
                    }),
                })
            } else {
                this.$q.notify({
                    type: 'positive',
                    message: this.$t('notify.course_added_to_wishlist'),
                })
            }

            this.loadingRemove(loadingKeys.addingToWishlist)
        },

        async fetchWishlistCount() {
            let parameters = {
                filter: {},
            }

            let response = await wishlistService.count(parameters)

            if (response.status === 200) {
                //update wishlist store counter
                store.dispatch(
                    'wishlist/updateCount',
                    response.data.results[0].count
                )
            }
        },

        async removeFromWishlist() {
            this.loadingAdd(loadingKeys.removingFromWishlist)

            let parameters = {
                data: [
                    {
                        course_id: this.course.id,
                        user_id: this.user.id,
                    },
                ],
            }

            let response = await wishlistService.delete(parameters)

            if (response.status !== 200) {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('notify.error_occurred', {
                        message: response.data.message,
                    }),
                })
            } else {
                this.$q.notify({
                    type: 'positive',
                    message: this.$t('notify.course_removed_from_wishlist'),
                })
                this.fetchWishlist()
            }

            this.loadingRemove(loadingKeys.removingFromWishlist)
        },

        async manageWishlist() {
            if (this.user) {
                this.wishlist.length
                    ? await this.removeFromWishlist()
                    : await this.addToWishlist()
                this.fetchWishlist()
            } else {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('errors.user_must_be_logged_in'),
                })
            }
        },

        async fetchWishlist() {
            this.loadingAdd(loadingKeys.fetchingWishlist)

            let parameters = {
                filter: {
                    user_id: this.user.id,
                    course_id: this.$route.params.id,
                },
            }

            let response = await wishlistService.retrieve(parameters)

            if (response.status === 200) {
                this.wishlist = response.data.results
                this.fetchWishlistCount()
            } else {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('notify.error_occurred', {
                        message: response.data.message,
                    }),
                })
            }

            this.loadingRemove(loadingKeys.fetchingWishlist)
        },

        toggleDialog() {
            this.contactForm = !this.contactForm
        },

        showForm() {
            this.form = {
                subject: this.JSONParseTranslations(
                    this.course.title,
                    this.locale.key
                ),
                message: this.$t(
                    'contact.please_tell_me_more_about_this_course'
                ),
            }
            this.contactForm = true
        },
    },
}
</script>

<style lang="scss">
.course-single-page {
    ol {
        padding-left: 18px;
    }
}
</style>
